import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import bannerReducer from './slices/bannerSlice';
import notificationReducer from './slices/notificationSlice'; 
import categoriesReducer from './slices/categoriesSlice';
import adminReducer from './slices/adminSlice';
import orderReducer from './slices/orderSlice';
import countriesReducer from './slices/countriesSlice';
import usersReducer from './slices/userSlice';
import auctionsReducer from './slices/auctionsSlice';
import clipsReducer from './slices/clipsSlice';
import withdrawalsReducer from './slices/withdrawalsSlice';
import dashboardReducer from './slices/dashboardSlice';
import languagesReducer from './slices/languagesSlice';
import channelsReducer from './slices/channelsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    admins: adminReducer,
    banners: bannerReducer,
    notification: notificationReducer, 
    categories: categoriesReducer,
    orders: orderReducer,
    countries:countriesReducer,
    users: usersReducer,
    auctions: auctionsReducer,
    clips: clipsReducer,
    withdrawals: withdrawalsReducer,
    dashboard: dashboardReducer,
    languages: languagesReducer,
    channels: channelsReducer,
  },
});

export default store;
